import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';
import { FormResponse } from 'src/app/models/forms/form-response.model';
import { FormTemplate } from 'src/app/models/forms/form-template.model';
import { environment } from 'src/environments/environment';


@Injectable({
	providedIn: 'root'
})
export class FormsService {

	private baseFormsUrl = `${environment.baseUrl}/forms`;

	constructor(private httpClient: HttpClient) { }

	@ApiMethod()
	getFormTemplates(token: string, jobSourcingTierId?: number, jobResourceId?: number): Observable<FormTemplate[]> {
		return this.httpClient.get<FormTemplate[]>(`${this.baseFormsUrl}/${token}`, {
			params: new HttpParams()
				.set('jobSourcingTierId', jobSourcingTierId ? jobSourcingTierId.toString() : '')
				.set('jobResourceId', jobResourceId ? jobResourceId.toString() : '')
		});
	}

	@ApiMethod()
	addFormResponse(token: string, model: FormResponse): Observable<{ lastUpdatedBy: string, jobFormResultId: number, collectedOn: Date }> {
		return this.httpClient.post<{ lastUpdatedBy: string, jobFormResultId: number, collectedOn: Date }>(`${this.baseFormsUrl}/${token}/results`, model);
	}

	@ApiMethod()
	updateFormResponseHistory(token: string, model: FormResponse): Observable<{ lastUpdatedBy: string, jobFormResultId: number, collectedOn: Date }> {
		return this.httpClient.post<{ lastUpdatedBy: string, jobFormResultId: number, collectedOn: Date }>(`${this.baseFormsUrl}/${token}/results/update-history`, model);
	}
}
